// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-wrapper{
    min-height: 100vh;
    display: flex;
    justify-content: center;
}
.divider {
    
    width: '70vw'; 
    height: '2px';  
    margin: '0 auto'
  }

/* Gradient animation for background */
@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* Subtle floating movement for background elements */
@keyframes floatSlow {
  0% {
    transform: translateY(0) translateX(0);
  }
  50% {
    transform: translateY(-10px) translateX(5px);
  }
  100% {
    transform: translateY(0) translateX(0);
  }
}

  
`, "",{"version":3,"sources":["webpack://./src/components/layout/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;AACA;;IAEI,aAAa;IACb,aAAa;IACb;EACF;;AAEF,sCAAsC;AACtC;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,sCAAsC;EACxC;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,sCAAsC;EACxC;AACF","sourcesContent":[".content-wrapper{\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n}\n.divider {\n    \n    width: '70vw'; \n    height: '2px';  \n    margin: '0 auto'\n  }\n\n/* Gradient animation for background */\n@keyframes gradientAnimation {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n/* Subtle floating movement for background elements */\n@keyframes floatSlow {\n  0% {\n    transform: translateY(0) translateX(0);\n  }\n  50% {\n    transform: translateY(-10px) translateX(5px);\n  }\n  100% {\n    transform: translateY(0) translateX(0);\n  }\n}\n\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
